module.exports = __webpack_public_path__ + "img/corner-left-up.d82d0dcb.svg";